// Libraries
var React = require('react');

// Style
require('./QualifioFormModule.scss');

class QualifioFormModule extends React.Component {
	constructor(props) {

		super(props);

		if (typeof window === 'undefined') return;
	
		this.clearExistingCookie();
	
	}

	clearExistingCookie() {

		const cookies = this.getCookies();

		for(var name in cookies) {

			if (name.indexOf('_qual_restore') !== -1) {

				document.cookie = name + '=; expires=Thu, 01 Jan 2010 00:00:00 UTC;';

			}

		}

	}

	getCookies() {

		let cookies = {};

		if (document.cookie && document.cookie != '') {

			const split = document.cookie.split(';');

			for (let i = 0; i < split.length; i++) {

				let nameValue = split[i].split("=");
				nameValue[0] = nameValue[0].replace(/^ /, '');
				cookies[decodeURIComponent(nameValue[0])] = decodeURIComponent(nameValue[1]);

			}

		}

		return cookies;
	}

	createContent() {

		return {__html: this.props.data.embedCode};
		
	};

	render() {
		
		return (
			<div id={this.props.data.id} className={`QualifioForm${this.props.data.fullWidth ? " QualifioForm--full-width" : ""}`}>
				<div className="QualifioForm__container">
					<div dangerouslySetInnerHTML={this.createContent()}></div>
				</div>
			</div>
		);
	}
};

module.exports = QualifioFormModule;



// WEBPACK FOOTER //
// ./src/components/QualifioForm/QualifioFormModule.js